import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ContactForm from "./components/ContactForm";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import KmlPage from "./pages/KmlPage";
import JewelPage from "./pages/JewelPage";
import Careers from "./pages/Careers";
import Newsevents from "./pages/NewsEvents";
import About from "./pages/About";
import Partners from "./pages/Partners";
import Mscs from "./pages/MscsPage";
import Nbfc from "./pages/NbfcPage";
import Mfi from "./pages/MfiPage";
import Chitty from "./pages/ChitPage";
import Mobileapp from "./pages/MobileAppsPage";
import Webservices from "./pages/WebServicePage";
import Ignosisolution from "./pages/IgnosiSolutionsPage";
import Fpc from "./pages/FpcPage";
import Nidhi from "./pages/NidhiPage";
import Gcalc from "./pages/GcalcPage";
// snehateam
import TeamProfile from "./pages/TeamProfile";

function Layout({ children }) {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      {children}
      <ContactForm />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <Home />
          </Layout>
        }
      />

      <Route
        path="/kml"
        element={
          <Layout>
            <KmlPage />
          </Layout>
        }
      />

      <Route
        path="/jewel"
        element={
          <Layout>
            <JewelPage />
          </Layout>
        }
      />

      <Route
        path="/careers"
        element={
          <Layout>
            <Careers />
          </Layout>
        }
      />
  
      <Route
        path="/news-events"
        element={
          <Layout>
            <Newsevents />
          </Layout>
        }
      />

      <Route
        path="/about"
        element={
          <Layout>
            <About />
          </Layout>
        }
      />
      <Route
        path="/partners"
        element={
          <Layout>
            <Partners />
          </Layout>
        }
      />
      <Route
        path="/mscs"
        element={
          <Layout>
            <Mscs />
          </Layout>
        }
      />

      <Route
        path="/nbfc"
        element={
          <Layout>
            <Nbfc />
          </Layout>
        }
      />
      <Route
        path="/mfi"
        element={
          <Layout>
            <Mfi />
          </Layout>
        }
      />
      <Route
        path="/chitty"
        element={
          <Layout>
            <Chitty />
          </Layout>
        }
      />
      <Route
        path="/mobileapps"
        element={
          <Layout>
            <Mobileapp />
          </Layout>
        }
      />
      <Route
        path="/webservices"
        element={
          <Layout>
            <Webservices />
          </Layout>
        }
      />
      <Route
        path="/ignosisolution"
        element={
          <Layout>
            <Ignosisolution />
          </Layout>
        }
      />
      <Route
        path="/fpcpage"
        element={
          <Layout>
            <Fpc />
          </Layout>
        }
      />
      <Route
        path="/nidhi"
        element={
          <Layout>
            <Nidhi />
          </Layout>
        }
      />
      <Route
        path="/gcalc"
        element={
          <Layout>
            <Gcalc />
          </Layout>
        }
      />
      {/* snehateam */}
      <Route path="/team/:id" element={<TeamProfile />} />
    </Routes>
  );
}

export default App;